import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

// Regex that allows:
// - Letters (A-Z, a-z)
// - Accents and diacritics (using Unicode categories)
// - Hyphens (-), apostrophes ('), and spaces
// - Must start and end with a letter (not space, hyphen, or apostrophe)
const nameRegex = /^[\p{L}][\p{L}\s'-]*[\p{L}]$|^[\p{L}]$/u

export const nameField = (key: 'first-name' | 'last-name') =>
  z
    .string()
    .trim()
    .nonempty(m(`${key}.required`))
    .min(2, m(`${key}.min-length`, { min: 2 }))
    .regex(nameRegex, { message: m(`${key}.invalid-characters`) })
